(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ts-essential-features"] && !Shopify.designMode) return;
  try {
    
  for (const row of document.querySelectorAll('.ts-essential-features__card-controls')) {
    if (row.__tsInited) continue;
    row.__tsInited = true;
    for (const eventName of ['mousedown', 'pointerdown', 'touchstart']) {
      row.addEventListener(eventName, (event) => event.stopPropagation());
    }
  }

  // Hide the swatches that overflow the row and set the "+N" counter.
  // Uses measured geometry; the no-JS fallback is a plain CSS clip.
  const tsFitSwatchRows = () => {
    for (const row of document.querySelectorAll('[data-swatch-overflow]')) {
      const swatches = row.querySelectorAll('.variant-option__button-label--has-swatch');
      if (!swatches.length) continue;

      for (const swatch of swatches) swatch.hidden = false;
      row.removeAttribute('data-swatch-hidden');

      const rowRect = row.getBoundingClientRect();
      if (!rowRect.width) continue; // panel not laid out (mobile)

      const lastRect = swatches[swatches.length - 1].getBoundingClientRect();
      if (lastRect.right <= rowRect.right + 1) continue; // everything fits

      const limit = rowRect.right - 40; // reserve room for "+NN"
      let visible = 0;
      for (const swatch of swatches) {
        if (swatch.getBoundingClientRect().right > limit) break;
        visible += 1;
      }
      visible = Math.min(Math.max(visible, 1), swatches.length - 1);

      for (let index = visible; index < swatches.length; index += 1) {
        swatches[index].hidden = true;
      }
      row.setAttribute('data-swatch-hidden', `+${swatches.length - visible}`);
    }
  };

  const tsRunSwatchFit = () => requestAnimationFrame(tsFitSwatchRows);
  const tsSwatchResizeObserver = new ResizeObserver(tsRunSwatchFit);

  // Re-runs on editor section re-renders, which replace the DOM.
  const tsInitSwatchRows = () => {
    for (const row of document.querySelectorAll('[data-swatch-overflow]')) {
      if (row.__tsSwatchObserved) continue;
      row.__tsSwatchObserved = true;
      tsSwatchResizeObserver.observe(row);
    }
    tsRunSwatchFit();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tsInitSwatchRows);
  } else {
    tsInitSwatchRows();
  }
  document.addEventListener('shopify:section:load', tsInitSwatchRows);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ts-pdp-details"]) return;
  try {
    
  class TsPdpDetailsCopy extends HTMLElement {
    connectedCallback() {
      if (this.__inited) return;
      this.__inited = true;

      this.content = this.querySelector('.ts-pdp-details__copy-content');
      this.button = this.querySelector('.ts-pdp-details__read-more');
      if (!this.content || !this.button) return;

      this.labelMore = this.dataset.labelMore || '';
      this.labelLess = this.dataset.labelLess || '';

      this.dataset.state = 'clamped';
      const overflows = this.content.scrollHeight > this.content.clientHeight;
      if (!overflows) {
        delete this.dataset.state;
        return;
      }

      this.button.addEventListener('click', () => this.#toggle());
    }

    #toggle() {
      const expanded = this.dataset.state === 'expanded';
      this.dataset.state = expanded ? 'clamped' : 'expanded';
      this.button.setAttribute('aria-expanded', String(!expanded));
      this.button.textContent = expanded ? this.labelMore : this.labelLess;
    }
  }

  if (!customElements.get('ts-pdp-details-copy')) {
    customElements.define('ts-pdp-details-copy', TsPdpDetailsCopy);
  }

  } catch(e) { console.error(e); }
})();
})();
